// The Terms and Privacy Policy live on the marketing site (landing/terms.html,
// landing/privacy.html). The app has no such routes: a relative "/terms" or
// "/legal" here falls through to the catch-all and bounces to the home page.
export const TERMS_URL = "https://visagenius.io/terms";
export const PRIVACY_URL = "https://visagenius.io/privacy";
